import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Table,
  Button,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";

const TotalBattle = () => {
  const [activeTab, setActiveTab] = useState("live");

  // Dummy battle data
  const battles = {
    live: [
      {
        id: "BT001",
        name: "Battle Royale",
        entryFee: 10,
        players: "45/100",
        status: "Live",
        startDate: "2026-02-07",
      },
    ],
    upcoming: [
      {
        id: "BT002",
        name: "War Zone",
        entryFee: 20,
        players: "0/50",
        status: "Upcoming",
        startDate: "2026-02-10",
      },
      {
        id: "BT003",
        name: "Clash Arena",
        entryFee: 15,
        players: "0/30",
        status: "Upcoming",
        startDate: "2026-02-12",
      },
    ],
    finished: [
      {
        id: "BT004",
        name: "Final Showdown",
        entryFee: 25,
        players: "50/50",
        status: "Finished",
        startDate: "2026-01-30",
      },
    ],
  };

  return (
    <div className="page-content">
      <Card className="mb-4">
        <CardBody>
          {/* Header */}
          <Row className="mb-3">
            <Col md={6}>
              <h4 className="card-title">Total Battles</h4>
            </Col>
            <Col md={6} className="text-end">
              <Button color="primary">Create Battle</Button>
            </Col>
          </Row>

          {/* Tabs */}
          <Nav tabs className="mb-3">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "live" })}
                onClick={() => setActiveTab("live")}
                style={{ cursor: "pointer" }}>
                Live
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "upcoming" })}
                onClick={() => setActiveTab("upcoming")}
                style={{ cursor: "pointer" }}>
                Upcoming
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "finished" })}
                onClick={() => setActiveTab("finished")}
                style={{ cursor: "pointer" }}>
                Finished
              </NavLink>
            </NavItem>
          </Nav>

          {/* Table */}
          <div className="table-responsive">
            <Table className="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Battle ID</th>
                  <th>Battle Name</th>
                  <th>Entry Fee ($)</th>
                  <th>Players</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {battles[activeTab].map((battle, index) => (
                  <tr key={battle.id}>
                    <td>{index + 1}</td>
                    <td>{battle.id}</td>
                    <td>{battle.name}</td>
                    <td>{battle.entryFee}</td>
                    <td>{battle.players}</td>
                    <td>
                      <span
                        className={`badge ${
                          battle.status === "Live"
                            ? "bg-success"
                            : battle.status === "Upcoming"
                              ? "bg-warning"
                              : "bg-secondary"
                        }`}>
                        {battle.status}
                      </span>
                    </td>
                    <td>{new Date(battle.startDate).toLocaleDateString()}</td>
                    <td>
                      <Button color="info" size="sm" className="me-2">
                        View
                      </Button>
                      <Button color="danger" size="sm">
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default TotalBattle;
